'use strict';

import React from 'react';
import Waypoint from 'react-waypoint';
import Footer from './FooterComponent';
import Navigator from './NavigatorComponent';
import Category from './CategoryComponent';
import Location from './LocationComponent';
import MediaList from './MediaListComponent';
import Loading from './LoadingComponent';
import API from 'sources/API';

import MediaActions from 'actions/MediaActions';
import MediaStore from 'stores/MediaStore';
import LocationStore from 'stores/LocationStore';
import LocationActions from 'actions/LocationActions';

import 'styles/Explore.scss';

class ExploreComponent extends React.Component {
  constructor(props) {
    super(props);
    let mediaStore = MediaStore.getState();
    let locationStore = LocationStore.getState();
    this.state = {
      showList: false,
      cid: null,
      location: locationStore.location,
      categoryList: mediaStore.categoryList,
      mediaList: mediaStore.mediaList,
      fetchTimeout: null,
      loading: mediaStore.loading,
      hasMore: mediaStore.hasMore,
      showNavigator: false,
      fixed: false,
      needRefresh: locationStore.needRefresh
    };
    this.onMediaChange = this.onMediaChange.bind(this);
    this.onMediaScroll = this.onMediaScroll.bind(this);
    this.fixCategoryComponent = this.fixCategoryComponent.bind(this);
    this.relativeCategoryComponent = this.relativeCategoryComponent.bind(this);
    this.onLocationChange = this.onLocationChange.bind(this); // 数据有变
    this.onCategoryChange = this.onCategoryChange.bind(this); // 数据有变
    this.loadMore = this.loadMore.bind(this)
  }
  componentWillMount() {
    // get categories
    if(!this.state.categoryList.length){
      MediaActions.fetchCategories();
    }
    
    // get media list
    let { query } = this.props.location;
    let { page } = this.props.params;

    let mediaStore = MediaStore.getState();
    if(query.id && query.type && mediaStore.shareTag && query.type !== 'world'){
      MediaActions.updateLocationId(query.id,query.type,query.cid,page);
      LocationActions.fetchLocation(query.id,query.type);
      this.state.showList = false;
      this.state.cid = query.cid;
    }else{
      if(query.cid){
        if(page){
          MediaActions.updateFirst(page);
        }
        MediaActions.updateCategoryId(query.cid);
        this.state.cid = query.cid;
      }else{
        if(this.state.mediaList.length === 0) {
          if(page){
            MediaActions.updateFirst(page);
          }
          MediaActions.fetchMediaList();
        }
      }
    }
  }
  componentDidMount() {
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
          window.wx.config(json);
        }
      })
    }
    let mediaStore = MediaStore.getState();
    // let locationStore = LocationStore.getState()
    if(this.state.needRefresh){
      window.scrollTo(0, 0);
      LocationActions.updateRefreshTag('0')
    }else{
      window.scrollTo(0, mediaStore.offset);
    }

    MediaStore.listen(this.onMediaChange);
    LocationStore.listen(this.onLocationChange);

    window.addEventListener('scroll', this.onMediaScroll);

    let query = this.props.location.query;
    if(query.id && query.type && mediaStore.shareTag && query.type !== 'world'){
      LocationActions.fetchLocationList({type:query.type,_id:query.id});
    }

    window._hmt.push(['_trackPageview', this.props.location.pathname]);
    window.changeMetaForSEO(false);
  }
  componentWillUnmount() {
    MediaActions.updateOffset($(document).scrollTop());
    MediaStore.unlisten(this.onMediaChange);
    LocationStore.unlisten(this.onLocationChange);
    window.removeEventListener('scroll', this.onMediaScroll);
  }
  onLocationChange(state) {
    if(!state.location) return;
    this.setState({
      location: state.location,
      needRefresh: state.needRefresh
    });
    window.wx.ready(()=>{
      let link = `${API.getWebsiteMediasHref}?type=${this.state.location.type}&id=${this.state.location._id}${this.state.cid?`&cid=${this.state.cid}`:''}`;
      let imgUrl = 'https://img.xiaodiqiu.cn/share.png';
      window.wx.onMenuShareTimeline({
        title: `${this.state.location.name}——加入小地球旅行，发现本星球最有趣的地方`, // 分享标题
        link: link, // 分享链接
        imgUrl: imgUrl // 分享图标
      });
      window.wx.onMenuShareAppMessage({
        title: `${this.state.location.name}——小地球旅行`, // 分享标题
        desc: '加入小地球旅行，发现本星球最有趣的地方', // 分享描述
        link: link, // 分享链接
        imgUrl: imgUrl, // 分享图标
        type: 'link', // 分享类型,music、video或link，不填默认为link
      });
    });
  }
  onCategoryChange(category){
    this.state.cid = category._id;
    window.wx.ready(()=>{
      let link = `${API.getWebsiteMediasHref}?type=${this.state.location.type}&id=${this.state.location._id}${this.state.cid?`&cid=${this.state.cid}`:''}`;
      let imgUrl = 'https://img.xiaodiqiu.cn/share.png';
      window.wx.onMenuShareTimeline({
        title: `${this.state.location.name}${category._id?`•${category.name}`:''}——加入小地球旅行，发现本星球最有趣的地方`, // 分享标题
        link: link, // 分享链接
        imgUrl: imgUrl // 分享图标
      });
      window.wx.onMenuShareAppMessage({
        title: `${this.state.location.name}${category._id?`•${category.name}`:''}——小地球旅行`, // 分享标题
        desc: '加入小地球旅行，发现本星球最有趣的地方', // 分享描述
        link: link, // 分享链接
        imgUrl: imgUrl, // 分享图标
        type: 'link' // 分享类型,music、video或link，不填默认为link
      });
    });
  }
  onMediaChange(media) {
    this.setState({
      categoryList: media.categoryList,
      mediaList: media.mediaList,
      loading: media.loading,
      hasMore: media.hasMore
    });
  }
  onMediaScroll(event) {
    if(this.state.fetchTimeout) {
      clearTimeout(this.state.fetchTimeout);
    }
    let scrollTop = $(document).scrollTop();
    let clientHeight = event.srcElement.body.clientHeight;
    let scrollHeight = event.srcElement.body.scrollHeight;

    if(scrollTop + clientHeight === scrollHeight) {
      MediaActions.setLoading(true);
      this.setState({fetchTimeout: setTimeout(MediaActions.fetchMediaList, 1000)});
    }
    if(scrollTop > 500){
      this.setState({showNavigator:true});
    }else{
      this.setState({showNavigator:false});
    }
  }
  loadMore() {
    MediaActions.setLoading(true);
    MediaActions.fetchMediaList()
  }
  fixCategoryComponent(){
    this.setState({fixed:true});
  }
  relativeCategoryComponent(){
    this.setState({fixed:false});
  }
  render() {
    let noMoreWord,navigator;
    if(this.state.mediaList.length === 0) {
      noMoreWord = ' ';
    }
    if(this.state.showNavigator){
      navigator = <Navigator action='top' />;
    }
    return (
      <div className="explore-component">
        <Location showList={this.state.showList} isExplore={true}/>
        <Waypoint
          onEnter={this.relativeCategoryComponent.bind(this)}
          onLeave={this.fixCategoryComponent.bind(this)}
        />
        <Category category={this.state.categoryList} fixed={this.state.fixed} cid={this.state.cid} onCategoryChange={this.onCategoryChange} />
        <MediaList medias={this.state.mediaList} loading={this.state.loading} fixed={this.state.fixed}/>
        <Loading noMoreWord={noMoreWord} loading={this.state.loading} hasMore={this.state.hasMore} loadMore={this.loadMore} />
        {navigator}
        <Footer/>
      </div>
    );
  }
}

ExploreComponent.displayName = 'ExploreComponent';

export default ExploreComponent;


// WEBPACK FOOTER //
// ./src/components/ExploreComponent.js